import React from 'react'
import { addWebPToImageURL, stripHTMLNonPhrasing } from 'Helpers/utilities'
import { getLazyImageAttributes, getLazySourceAttributes } from './lazyMediaHelpers'

const HeroBannerSlideWithBackgroundImageBlock = ({ data, inEditMode, shouldLazyLoad }) => {
  const { BackgroundImage, MobileBackgroundImage, TextColor, HeroHeading, HeroSubheading, HeroCta, ButtonColor, HeroCtaAlignment, ContentTextAlignment } = data;
  const Link = HeroCta.Value[0];
  const heroCtaAlignment = HeroCtaAlignment === 'left' ? 'text-left' : HeroCtaAlignment === 'center' ? 'text-center' : 'text-right';
  const textAlignment = ContentTextAlignment === 'left' ? 'text-left' : ContentTextAlignment === 'center' ? 'text-center' : 'text-right';
  const buttonColorClasses = ButtonColor === 'light' ? 'bg-[#d3d9ff] hover:bg-[#b6b8ff] text-black border-[#d3d9ff] hover:border-[#b6b8ff]' : 'bg-violet hover:bg-violet-dark text-white border-violet hover:border-violet-dark';

  const backgroundImageUrl = addWebPToImageURL(BackgroundImage?.Url);
  const mobileBackgroundImageUrl = MobileBackgroundImage ? addWebPToImageURL(MobileBackgroundImage?.Url) : backgroundImageUrl;
  const lazyEnabled = shouldLazyLoad && !inEditMode;
  const eager = !lazyEnabled;

  const mobileSourceProps = {
    media: '(max-width: 768px)',
    ...getLazySourceAttributes({ srcSet: mobileBackgroundImageUrl, eager })
  };
  const desktopSourceProps = {
    media: '(min-width: 769px)',
    ...getLazySourceAttributes({ srcSet: backgroundImageUrl, eager })
  };

  const imageAttributes = {
    alt: BackgroundImage?.AltTag,
    className: 'absolute z-[-1] inset-0 w-full h-full object-cover',
    loading: lazyEnabled ? 'lazy' : 'eager',
    ...getLazyImageAttributes({ src: backgroundImageUrl, eager })
  };

  return (
    <div className='relative bg-no-repeat bg-cover bg-center h-full'>
      <picture>
        <source {...mobileSourceProps} />
        <source {...desktopSourceProps} />
        <img {...imageAttributes} />
      </picture>
      <div className='container mx-auto max-w-screen-xl h-full'>
        <div className={`flex flex-col justify-center h-full mx-6 sm:mx-8 md:mx-12 lg:mx-12 xl:mx-24 ${TextColor}`} >
          <div className={`text-xl md:text-3xl lg:text-6xl font-medium font-display py-2 lg:py-6 ${textAlignment}`}>
            <h2 dangerouslySetInnerHTML={{ __html: stripHTMLNonPhrasing(HeroHeading) }}></h2>
          </div>
          {HeroSubheading && (
            <div className={`lg:text-lg md:text-base text-sm md:font-medium md:font-display font-body mb-4 ${textAlignment}`}>
              <h3 dangerouslySetInnerHTML={{ __html: stripHTMLNonPhrasing(HeroSubheading) }}></h3>
            </div>
          )}
          {Link && (
            <div className={`mt-2 ${heroCtaAlignment}`}>
              <a data-epi-edit="HeroCta" href={`${Link?.Href}`} target={`${Link?.Target}`} title={`${Link?.Title}`}
                className={`focus:outline-none rounded-full font-medium font-body md:text-base 
                sm:text-sm text-xs border-2 lg:py-2.5 py-2 md:px-8 sm:px-6 px-4 whitespace-nowrap ${buttonColorClasses}`}>
                {Link?.Text}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default React.memo(HeroBannerSlideWithBackgroundImageBlock)
